import { BotbPassDrawerContext } from "./botb-pass-drawer-context";
import { ReactNode, useEffect, useState } from "react";
import { getAvailableSubscriptions } from "../botb-pass/subscription-service";
import { updateSubscriptionUpsellWidget } from "./botb-pass-drawer-service";
import { getPreSubscriptionData } from "../upsell-subscription-modal/subscription-service";
import { useAppDispatch } from "../../redux/hooks";
import { publishModalVisibility } from "../../redux/features/modal/modalSlice";

const BotbPassDrawerProvider = ({
  children,
  shouldShowSubscriptionDrawer,
  overrideDesktopDisplaying = false,
}: {
  children: ReactNode;
  shouldShowSubscriptionDrawer?: boolean;
  overrideDesktopDisplaying?: boolean;
}) => {
  const dispatch = useAppDispatch();
  const [allPackages, setAllPackages] = useState<Package[]>([]);
  const [shouldShowDrawer, setShouldShowDrawer] = useState<boolean>(shouldShowSubscriptionDrawer || false);
  const [isDrawerOpen, setIsDrawerOpen] = useState<boolean>(overrideDesktopDisplaying);
  const [preSubscriptionData, setPreSubscriptionData] = useState<PreSubscriptionData>({
    features: [],
    header: {
      subtitlep1: "",
      subtitlep2: "",
      subtitlep3: "",
      title: "",
      video: "",
      videoMobile: "",
      legalText: "",
    },
    offer: {
      bonus: "",
      description: "",
      expireTime: 0,
      headline: "",
      offerImage: "",
    },
  });
  const [preSubscriptionDataLoading, setPreSubscriptionDataLoading] = useState<boolean>(false);

  const createSortedData = (data: Package[]) => {
    return [...data].sort(
      (a, b) =>
        a.prices.find(price => price.interval === "month").unit_amount -
        b.prices.find(price => price.interval === "month").unit_amount
    );
  };

  useEffect(() => {
    if (!shouldShowDrawer) {
      return;
    }
    getAvailableSubscriptions()
      .then(res => res.json())
      .then(res => {
        if (res !== null) {
          setAllPackages(createSortedData(res));
        }
      })
      .catch(err => console.error(err));
    setPreSubscriptionDataLoading(true);
    getPreSubscriptionData(false, "default")
      .then(res => res.json())
      .then(res => {
        setPreSubscriptionData(res);
        setPreSubscriptionDataLoading(false);
      })
      .catch(err => console.error(err));
  }, [shouldShowDrawer]);

  const onClickClose = () => {
    updateSubscriptionUpsellWidget(false)
      .then(res => {
        setShouldShowDrawer(false);
      })
      .catch(err => console.error(err));
  };

  const closeModal = () => {
    setIsDrawerOpen(false);
    dispatch(publishModalVisibility({ isOpen: false }));
  };

  return (
    <BotbPassDrawerContext.Provider
      value={{
        allPackages,
        onClickClose,
        shouldShowDrawer,
        isDrawerOpen,
        setIsDrawerOpen,
        preSubscriptionDataLoading,
        preSubscriptionData,
        closeModal,
        overrideDesktopDisplaying,
      }}>
      {children}
    </BotbPassDrawerContext.Provider>
  );
};

export default BotbPassDrawerProvider;
